import { TextField, useMediaQuery } from '@mui/material';
import { breakpoints } from '../../constants';
import { Row } from '../Row';
import { TFormValues } from '../../types';
import { useTranslation } from 'react-i18next';

interface IProps {
    formValues: TFormValues;
    getFieldError: (fieldName: keyof TFormValues) => string | undefined;
    setFieldValue(field: keyof TFormValues, value: string): void;
}

export const RelocationAddressSection = ({
    formValues,
    getFieldError,
    setFieldValue,
}: IProps) => {
    const { t } = useTranslation();
    const mediumBreakpoint = useMediaQuery(`(${breakpoints.mediumMin})`);

    return (
        <>
            <Row>
                <TextField
                    error={!!getFieldError('newZipcode')}
                    helperText={getFieldError('newZipcode')}
                    id={formValues.newZipcode}
                    label={t('zipcode') + ' *'}
                    value={formValues.newZipcode}
                    onChange={(e) =>
                        setFieldValue('newZipcode', e.target.value)
                    }
                />
                <TextField
                    error={!!getFieldError('newHouseNumber')}
                    helperText={getFieldError('newHouseNumber')}
                    id={formValues.newHouseNumber}
                    label={t('houseNumber') + ' *'}
                    sx={{ marginLeft: `${mediumBreakpoint && '10px'}` }}
                    value={formValues.newHouseNumber}
                    onChange={(e) =>
                        setFieldValue('newHouseNumber', e.target.value)
                    }
                />
            </Row>
            <TextField
                error={!!getFieldError('newStreet')}
                helperText={getFieldError('newStreet')}
                id={formValues.newStreet}
                label={t('street') + ' *'}
                value={formValues.newStreet}
                onChange={(e) => setFieldValue('newStreet', e.target.value)}
            />
            <TextField
                error={!!getFieldError('newCity')}
                helperText={getFieldError('newCity')}
                id={formValues.newCity}
                label={t('city') + ' *'}
                value={formValues.newCity}
                onChange={(e) => setFieldValue('newCity', e.target.value)}
            />
        </>
    );
};
